export class ConversionError extends Error {
  constructor(domain: string, fromUnit: string, toUnit: string, value: number) {
    super(`Failed to convert ${value} from ${fromUnit} to ${toUnit} within ${domain} domain.`);
    Object.setPrototypeOf(this, ConversionError.prototype);
  }
}
